import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import emailjs from '@emailjs/browser';
import './Newsletter.css';

const Newsletter = () => {
  const { isDarkMode } = useTheme();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // EmailJS credentials from environment variables
      const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_d6jjww9';
      const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'template_jsl3ujt';
      const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'nLsyduh05SkoaGYzB';

      const templateParams = {
        from_name: `${formData.firstName} ${formData.lastName}`,
        from_email: formData.email,
        to_name: 'E-Q.O.L. Team',
        subject: 'Newsletter Signup',
        message: `New newsletter subscription:\n\nName: ${formData.firstName} ${formData.lastName}\nEmail: ${formData.email}\n\nPlease add this person to the newsletter list.`,
      };

      await emailjs.send(serviceId, templateId, templateParams, publicKey);
      
      setSubmitStatus('success');
      setFormData({ firstName: '', lastName: '', email: '' });
    } catch (error) {
      console.error('Error sending email:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="newsletter" className="newsletter section">
      <div className="container">
        <div className="newsletter-content">
          <div className="newsletter-left">
            <div className="newsletter-hero">
              <div className="newsletter-hero-video">
                <video 
                  src="/videos/6646671-hd_1080_1920_24fps.mp4" 
                  className="hero-bg-video"
                  autoPlay
                  muted
                  loop
                  playsInline
                />
                <div className="hero-content-overlay">
                  <h2>Join us and be the change.</h2>
                  <p>
                    There are countless ways to be part of E-Q.O.L. Whether you want to volunteer your time, 
                    contribute your skills, or help grow our movement, every action brings us closer to a more inclusive world.
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="newsletter-right">
            <div className="newsletter-form-container">
              <div className="newsletter-header">
                <div className="newsletter-logo">
                  <img 
                    src="/images/no backround.png" 
                    alt="E-Q.O.L. Logo" 
                    className="logo-image"
                  />
                </div>
                <h3>Stay Connected with E-Q.O.L.</h3>
                <p>Join our community and receive monthly updates on our research, events, and impact stories.</p>
              </div>
              
              <form className="newsletter-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="firstName">First Name *</label>
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      placeholder="Enter your first name"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="lastName">Last Name *</label>
                    <input
                      type="text"
                      id="lastName"
                      name="lastName"
                      placeholder="Enter your last name"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="your.email@example.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-footer">
                  {submitStatus === 'success' && (
                    <div className="newsletter-success-message">
                      <p>✅ Thank you for subscribing! You'll receive our monthly newsletters.</p>
                    </div>
                  )}
                  
                  {submitStatus === 'error' && (
                    <div className="newsletter-error-message">
                      <p>❌ Sorry, there was an error. Please try again or contact us directly.</p>
                    </div>
                  )}

                  <button 
                    type="submit" 
                    className="newsletter-submit-btn"
                    disabled={isSubmitting}
                  >
                    <span>{isSubmitting ? 'Subscribing...' : 'Subscribe to Newsletter'}</span>
                    {!isSubmitting && (
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    )}
                  </button>
                  <p className="privacy-note">
                    We respect your privacy. Unsubscribe at any time.
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
